/**
 * Captures a screenshot from a video element
 * @param videoElement - The HTML video element to capture
 * @returns Base64 encoded PNG image or null if capture fails
 */
export const captureScreenshot = (
  videoElement: HTMLVideoElement | null
): string | null => {
  if (!videoElement) return null;

  try {
    const canvas = document.createElement('canvas');
    canvas.width = videoElement.videoWidth;
    canvas.height = videoElement.videoHeight;

    const ctx = canvas.getContext('2d');
    if (!ctx) return null;

    // Draw the video frame to the canvas
    ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

    // Convert the canvas to a base64 encoded PNG
    return canvas.toDataURL('image/png');
  } catch (error) {
    console.error('Error capturing screenshot:', error);
    return null;
  }
};